// grid used in Study Files tab for Files and Checklists sub-tabs
// TODO: rename to GridTypeB or another more descriptive name
import React, { useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';

import './grid.scss';

const Grid = ({
  ref,
  columnDefs,
  onGridReady,
  gridOptions,
  rowData,
  gridApi,
  search,
  onSortChanged,
  onFilterChanged,
  onRowDragMove,
  getRowNodeId,
  variant = "primary",
  pagination = false,
  paginationPageSize = null,
  containerStyle = {},
  className,
}) => {

  useEffect(() => {
    if (gridApi) {
      if (search) {
        gridApi.setQuickFilter(search)
      } else {
        gridApi.setQuickFilter("")
      }
    }
  }, [search, gridApi])

  let classNames = ["study-files-grid"];
  switch (variant) {
    case "secondary":
      classNames.push("secondary-grid-container")
      break;
    default:
      classNames.push("primary-grid-container")
  }
  if (className) classNames.push(className);

  return (
    <div
      className={classNames.join(" ")}
      style={containerStyle}
    >
      <AgGridReact
        ref={ref}
        columnDefs={columnDefs}
        domLayout='autoHeight'
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        rowData={rowData}
        onSortChanged={onSortChanged}
        onFilterChanged={onFilterChanged}
        onRowDragMove={onRowDragMove}
        getRowNodeId={getRowNodeId}
        pagination={pagination}
        paginationPageSize={paginationPageSize}
      />
    </div>
  );
};

export default Grid;